/**
 * Caregiver Routes Configuration
 * 
 * These routes are accessed through the hamburger menu and are intended
 * for caregivers only. Accessibility input methods (eye control, scanning,
 * virtual cursor) are disabled on these pages.
 * 
 * @module caregiverRoutes
 */

/**
 * List of route prefixes that are caregiver-only pages
 * These are accessed via the hamburger menu and should only be controlled
 * via mouse/touch, not via accessibility input methods
 */
export const CAREGIVER_ROUTE_PREFIXES = [
  '/settings',
  '/control',
  '/board-editor',
  '/board-cell-edit',
  '/home-editor',
  '/entertainment-editor',
  '/keyboard-editor',
  '/keyboard-phrases-editor',
  '/communication-action-bar-editor',
  '/guide',
  '/volume',
  '/onboarding',
  '/action-mapping',
  '/contacts-settings',
  '/smart-home-button-edit',
  '/user-contacts',
  '/legal',
  '/cookies',
];

/**
 * Check if a given path is a caregiver-only route
 * @param pathname - The current route pathname
 * @returns true if the route is for caregivers only
 */
export function isCaregiverRoute(pathname: string): boolean {
  return CAREGIVER_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix));
}
